<template>
  <ul v-if="validationFields.length" class="form-validation-list">
    <li
      v-for="field in validationFields"
      :key="field.key"
      style="line-height: 1.125 !important"
    >
      <span class="font-bold text-2xs text-grey-800">{{ getLabel(field.key, field.label) }} </span>
      <ul class="form-validation-rules">
        <li v-if="!field.attributes.required">
          Optional field.
        </li>
        <li
          v-for="(value, rule, index) in availableRules(field.validation)"
          :key="index"
        >
          {{ __(value, field.type, rule) }}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import { competitionStreamsMixin } from "../../mixins/competitionStreams";

const _dictionary = Object.freeze({
  text: {
    limit: " character limit."
  },
  upload: {
    accept: " files only.",
    limit: "mb file limit."
  },
  multiline: {
    limit: " word limit."
  }
});
export default {
  name: "InputValidationDetails",
  mixins: [competitionStreamsMixin],
  props: {
    fields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      stream: null
    };
  },
  computed: {
    validationFields() {
      return this.fields.filter(item => {
        return Object.keys(this.availableRules(item.validation)).length;
      });
    }
  },
  mounted() {
    this.stream = this.$page?.project?.stream ?? null;
    document.addEventListener("apc:stream", e => {
      this.stream = e.detail;
    });
  },
  methods: {
    getLabel(key, d) {
      return this.getStreamOverideForKey(
        this.stream,
        key,
        "label",
        d
      );
    },
    __(value, type, rule) {
      if (!_dictionary.hasOwnProperty(type)) return;
      if (!_dictionary[type].hasOwnProperty(rule)) return;
      if (Array.isArray(value)) value = value.join(", ");
      return value + _dictionary[type][rule];
    },
    availableRules(validation) {
      return pickBy(validation, identity);
    }
  },
};
</script>

<style>
.form-validation-list {
  @apply list-reset pb-6;
}

.form-validation-rules {
  @apply list-reset text-grey-600 italic font-semibold text-sm;
}

.form-validation-rules li {
  @apply mb-1;
}
</style>
